import { Icon } from '@fm-nx/svg';
import LinkWrapper from '../link-wrapper/link-wrapper';
import type { SearchHit } from '../search/search-hit-types';

export interface SearchHitListItemProps {
    hit: SearchHit;
}

export function SearchHitListItem(props: SearchHitListItemProps) {
    const { hit } = props;
    return (
        <LinkWrapper href={hit.url} className="text-white gtm-search-hit__link group">
            <div className="grid grid-cols-12 pb-8 mb-8 space-y-3 border-b border-white md:space-y-0 md:grid-cols-14 md:grid-rows-1">
                <div className="col-span-12 md:col-span-2">
                    <span className="text-white overline h5">{hit.contentTypeDisplay}</span>
                </div>
                <div className="col-span-11 space-y-3 md:col-span-11">
                    <span className="text-white h-md border-b-in after:bg-white">{hit.title}</span>
                    <div>{hit.summary}</div>
                </div>
                <div className={`col-span-1`}>
                    <div className="flex justify-end group-hover:animate-bounce-right">
                        <Icon name="arrow" color="white" />
                    </div>
                </div>
            </div>
        </LinkWrapper>
    );
}

export default SearchHitListItem;
